/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Class build categories graph to choose all selected categories
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.4.0
 */

import { IProductsCategory } from '../tariffsAndServicesTypes';

export class TariffsAndServicesCategoryGraph {
    nodes: Map<number, number> // contains pair category child id : parent id
    selectedNodesId: Set<number>

    constructor(categories: IProductsCategory[]) {
        this.nodes = new Map();
        this.selectedNodesId = new Set();

        for (const category of categories) {
            this.nodes.set(category.id, category.parent);
        }
    }

    // recursively select parent on all levels
    private selectParentNode(childNode: number): void {
        const parentNode = this.nodes.get(childNode);
        if (parentNode && !this.selectedNodesId.has(parentNode)) {
            this.selectedNodesId.add(parentNode);
            this.selectParentNode(parentNode);
        }
    }

    public getAllSelectedCategories(childCategoriesId: number[]): number[] {
        for (const categoryId of childCategoriesId) {
            if (this.nodes.has(categoryId)) {
                this.selectParentNode(categoryId);
            }
        }
        return [...childCategoriesId, ...Array.from(this.selectedNodesId)];
    }
}
